<template>
  <div class="d-flex justify-center align-center">
    <v-btn-toggle dense>
      <v-btn
        style="border-width: 1px !important;"
        :disabled="!offersDelivery || checkBreakfastMode"
        :color="isDelivery ? 'success' : ''"
        @click="toggle(true)"
        :dark="isDelivery"
        height="35"
      >
        <v-badge
          v-if="offersDelivery"
          :value="!!!deliveryInfo"
          color="error"
          left
        >
          <template v-slot:badge>
            <v-icon color="white" size="15"
              >mdi-map-marker-question-outline
            </v-icon>
          </template>
          <font-awesome-icon
            :icon="['fal', 'biking-mountain']"
            :style="{
              color: isDelivery ? 'white' : 'black',
              fontSize: '18px'
            }"
          ></font-awesome-icon>
          <span :style="{ color: isDelivery ? 'white' : 'black' }">{{
            $t("delivery.lang_delivery")
          }}</span>
        </v-badge>
        <template v-else>
          <font-awesome-icon
            :icon="['fal', 'biking-mountain']"
            :style="{ color: 'black', fontSize: '18px' }"
          ></font-awesome-icon>
          <span :style="{ color: 'black' }">{{
            $t("delivery.lang_delivery")
          }}</span>
        </template>
      </v-btn>

      <v-btn
        style="border-width: 1px !important;"
        :disabled="!offersPickUp"
        :color="!isDelivery ? 'success' : ''"
        :dark="!isDelivery"
        height="35"
        @click="toggle(false)"
      >
        <font-awesome-icon
          :icon="['fal', 'burger-soda']"
          :style="{
            color: !isDelivery ? 'white' : 'black',
            fontSize: '18px'
          }"
        ></font-awesome-icon>
        <span :style="{ color: !isDelivery ? 'white' : 'black' }">{{
          $t("delivery.lang_pickup")
        }}</span>
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBikingMountain,
  faBurgerSoda
} from "@fortawesome/pro-light-svg-icons";
import { createNamespacedHelpers } from "vuex";
import { isBreakfast } from "../../helpers/breakfast";

library.add({
  faBurgerSoda,
  faBikingMountain
});

export default {
  name: "DeliveryModeToggle",

  components: {
    "font-awesome-icon": FontAwesomeIcon
  },

  computed: {
    ...createNamespacedHelpers("Config").mapGetters([
      "offersDelivery",
      "offersPickUp",
      "isDelivery",
      "deliveryInfo"
    ]),

    checkBreakfastMode() {
      return isBreakfast();
    }
  },

  methods: {
    ...createNamespacedHelpers("Config").mapActions(["applyDeliveryMode"]),

    async toggle(status) {
      if (this.isDelivery === status) {
        if (status && !this.deliveryInfo) {
          this.$root.$emit("toggleDeliveryAreaDialog", true);
        }
        return;
      }

      this.$emit("before-switch", status);

      if (status && !this.offersDelivery) {
        this.$swal({
          title: this.$t("generic.lang_Warning"),
          icon: "warning",
          text: this.$t("delivery.lang_cantAcceptDelivery")
        });
      } else if (!status && !this.offersPickUp) {
        this.$swal({
          title: this.$t("generic.lang_Warning"),
          icon: "warning",
          text: this.$t("delivery.lang_cantAcceptPickup")
        });
      }

      const removed = await this.applyDeliveryMode(status);

      if (removed && removed.length) {
        this.$swal({
          title: this.$t("generic.lang_Warning"),
          icon: "warning",
          text:
            this.$t("delivery.lang_itemsRemovedAfterModeSwitch") +
            ": " +
            removed.map(i => i.name).join(", ")
        });
      }

      this.$emit("changed", status);
    }
  }
};
</script>
